import { httpClient } from './httpClient';

export async function listar(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.append(k, v);
  });
  const qs = params.toString();
  return httpClient.get(`/api/novedades${qs ? `?${qs}` : ''}`);
}

export async function listSelects() {
  return httpClient.get('/api/novedades/selects');
}

export const obtenerNovedad = (id) => httpClient.get(`/api/novedades/${id}`);
export const crearNovedad = (payload) => httpClient.post('/api/novedades', payload);
export const actualizarNovedad = (id, payload) => httpClient.put(`/api/novedades/${id}`, payload);
export const eliminarNovedad = (id) => httpClient.del(`/api/novedades/${id}`);

const novedadesService = {
  listar,
  listSelects,
  obtener: obtenerNovedad,
  crear: crearNovedad,
  actualizar: actualizarNovedad,
  eliminar: eliminarNovedad,
};
export default novedadesService;
